export default "__VITE_ASSET__C3EFqL7P__"